// NotFound.tsx
import { ErrorWrapper } from '@/components/organisms/ErrorWrapper/ErrorWrapper'
import SEO from '@/components/atoms/SEO/SEO'

export function NotFound(): JSX.Element {
  return (
    <>
      <SEO
        title='404 | Lumar Prestige'
        description='Página no encontrada en Lumar Prestige.'
        url={typeof window !== 'undefined' ? window.location.href : ''}
        keywords={['404', 'error', 'not found', 'Lumar Prestige']}
      />
      <ErrorWrapper title='error' errorCode='404' />
    </>
  )
}
